export default {
    showError: false,
    showLoader: true,
    showContent: false
};